<template>
  <div
    :class="`invadobay-preview ${
      container ? 'container invadobay-preview__container' : ''
    }`"
  >
    <custom-link
      :id="`invadobay-compact-preview-${elem.slug}-${_uid}`"
      route_name="invadobay"
      :route_path="`/invadobay/${elem.slug}`"
      :wrapper_class="`invadobay-preview__compact ${
        elem.ratio === 'landscape' ? 'landscape' : 'square'
      }`"
      :css_class="'h-100'"
      :as_default="get_config('guiSettings.openDetailNewTab', false)"
    >
      <template #content>
        <!-- properties -->
        <img
          v-if="elem.cover_media"
          class="invadobay-preview__compact-image"
          :src="(elem.cover_media || {}).url || ''"
          :alt="elem.title"
        />
        <img
          v-else
          class="invadobay-preview__compact-image invadobay-preview__compact-image--missing"
          :src="default_image"
          :alt="elem.title"
        />

        <!-- content -->
        <div
          class="invadobay-preview__compact-overlay w-100 h-100 d-flex flex-column justify-content-end"
        >
          <div
            class="invadobay-preview__compact-overlay-text d-flex align-items-center justify-items-center"
          >
            <div ref="title_text" class="text-nowrap text-truncate mr-2">
              {{ elem.title }}
            </div>
            <vb-icon
              :name="'angle_right'"
              :color="sass('secondary')"
              :size="15"
            />
          </div>
        </div>
      </template>
    </custom-link>
    <b-popover
      v-if="title_tooltip"
      :target="`invadobay-compact-preview-${elem.slug}-${_uid}`"
      triggers="hover"
      placement="bottom"
      custom-class="b-popover--dark b-popover--no-arrow"
    >
      <span class="text--base">
        {{ title_tooltip }}
      </span>
    </b-popover>
  </div>
</template>

<script>
import { get_config } from "@/utilities/commons";

export default {
  name: "invadobay-compact-preview",
  props: {
    elem: Object,
    container: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      title_tooltip: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.title_tooltip = this.is_text_truncated(this.$refs.title_text)
        ? this.elem.title
        : "";
    });
  },
  methods: {
    get_config,
  },
  computed: {
    default_image() {
      if (this.is_vivamod()) {
        return `/assets/email/logo-vivamod-mt.png`;
      }
      if (this.is_hotels()) {
        return `/assets/email/logo-vivamod-hotels.png`;
      }
      return `/assets/email/logo-vadobay-live.png`;
    },
  },
};
</script>

<style lang="scss" scoped>
.invadobay-preview {
  .landscape {
    aspect-ratio: 2 / 1;
    img {
      min-width: 100% !important;
      min-height: auto !important;
    }
  }
  .square {
    aspect-ratio: 1 / 1;
  }
  &__compact {
    padding: 0;
    position: relative;
    overflow: hidden;
    border-radius: $border-radius-lg * 2 !important;

    &-image {
      min-height: 100% !important;
      min-width: auto;
      object-fit: cover;
      &--missing {
        object-fit: scale-down;
        background-color: white;
        padding: 60px;
      }
    }

    &-overlay {
      position: absolute;
      top: 0;
      background: linear-gradient(180deg, #f2f1f100 0%, #000000f0 100%);

      &-text {
        color: white;
        font-size: $font-size-xl;
        font-weight: $vb-font-weight-semibold;
        text-decoration: underline;
        margin: $paragraph-margin-bottom * 2;
      }
    }
  }
}
</style>
